<footer class="d-flex flex-row justify-content-between">
  <img class="img-fluid my-auto ml-3 telefonica" src="../../../../assets//images//footer/logo_telefonica_med@2x.png" *ngIf="true" />

  <img alt="{{version}}" class="img-fluid my-auto mr-3" src="../../../../assets//images//footer/logo_timwe_small@2x.png" />
</footer>

<!-- <footer class="d-flex flex-row justify-content-between">
  <div class="my-auto ml-3">
    <img class="img-fluid logo-xl-axiata" src="../../../../assets//images//footer/Iogo_xl_axiata@2x.png" />
    <span class="text-xl-axiata ml-3">© PT XL Axiata Tbk</span>
  </div>

  <img class="img-fluid my-auto mr-3" src="../../../../assets//images//footer/logo_timwe_small@2x.png" />
</footer> -->
